import React from 'react';
import { DarkMode } from 'use-dark-mode';

import {
    ChangePasswordForm,
    UserAONLayout,
    UserLayout,
    UserSgiffoxxLayout,
    UserAonMotorLayout,
    UserCeatLayout,
} from 'src/user-management';

import { CeatThemeProvider } from 'src/shared/hocs/ceat-theme-provider';
import { AonThemeProvider } from 'src/shared/hocs/aon-theme-provider';
import { HectorThemeProvider } from 'src/shared/hocs/hector-theme-provider';
import { appInstance } from 'src/environment';
import { AppInstances } from 'src/shared/constants';
import { UserHectorLayout } from 'src/user-management';
import { AonMotorThemeProvider } from 'src/shared/hocs/aon-motor-theme-provider';

import { useAuth } from 'src/user-management/context-auth';

interface Props {
    darkMode: DarkMode;
}

export const ChangePasswordPage = ({ darkMode }: Props): JSX.Element => {
    const { homePath } = useAuth();

    switch (appInstance) {
        case AppInstances.AON:
        case AppInstances.AON_KOMPOSIT: {
            return (
                <AonThemeProvider>
                    <UserAONLayout darkMode={darkMode} backPath={homePath}>
                        <ChangePasswordForm darkMode={darkMode} />
                    </UserAONLayout>
                </AonThemeProvider>
            );
        }
        case AppInstances.AON_DIGITAL:
        case AppInstances.AON_MOTOR:
        case AppInstances.HECTOR_DEMO: {
            return (
                <AonMotorThemeProvider>
                    <UserAonMotorLayout darkMode={darkMode} backPath={homePath}>
                        <ChangePasswordForm darkMode={darkMode} />
                    </UserAonMotorLayout>
                </AonMotorThemeProvider>
            );
        }
        case AppInstances.SGIFFOXXK: {
            return (
                <UserSgiffoxxLayout darkMode={darkMode}>
                    <ChangePasswordForm darkMode={darkMode} />
                </UserSgiffoxxLayout>
            );
        }
        case AppInstances.HECTOR: {
            return (
                <HectorThemeProvider>
                    <UserHectorLayout darkMode={darkMode}>
                        <ChangePasswordForm darkMode={darkMode} />
                    </UserHectorLayout>
                </HectorThemeProvider>
            );
        }
        case AppInstances.CEAT: {
            return (
                <CeatThemeProvider>
                    <UserCeatLayout darkMode={darkMode}>
                        <ChangePasswordForm darkMode={darkMode} />
                    </UserCeatLayout>
                </CeatThemeProvider>
            );
        }
        default: {
            return (
                <UserLayout darkMode={darkMode}>
                    <ChangePasswordForm darkMode={darkMode} />
                </UserLayout>
            );
        }
    }
};
